export default class DeviceProfileService {
	constructor(apiService) {
		this.apiService = apiService
	}

	getEntitiesForSelectBox(params) {
		return this.apiService.callGet('me/deviceProfiles/simple', params)
	}

	getEntity(id, params) {
		return this.apiService.callGet('me/deviceProfile/' + id, params)
	}

	getEntities(params) {
		return this.apiService.callGet('me/deviceProfiles', params)
	}

	deleteEntity(id, params) {
		return this.apiService.callDelete('me/deviceProfile/' + id, params)
	}

	updateEntity(id, params) {
		return this.apiService.callPut('me/deviceProfile/' + id, params)
	}

	createEntity(params) {
		return this.apiService.callPost('me/deviceProfile/', params);
	}

	getDependency() {
		return this.apiService.callGet('me/deviceProfile/dependency/')
	}
}



// WEBPACK FOOTER //
// ./src/service/DeviceProfileService.js